export const searchJobHitZeroWhenPostedDateHiddenVar =
  '--search-job-hit-zero-when-posted-date-hidden';

export const searchJobHitTransparentWhenBorderHiddenVar =
  '--search-job-hit-transparent-when-border-hidden';
